import { createSelector } from "@reduxjs/toolkit";
import { companyMemberGroupDetailsAdapter } from "@store/company-member-groups/company-member-groups-slice";
/**
 * Returns all groups for the provided company member.
 */
export const companyMemberGroupsSelector = createSelector(state => state.companyMemberGroups, companyMemberGroups => {
  return companyMemberGroupDetailsAdapter.getSelectors().selectAll(companyMemberGroups);
});

/**
 * Returns the fetching status of the company member group slice.
 */
export const companyMemberGroupsStatusSelector = createSelector(state => state.companyMemberGroups, companyMemberGroups => {
  return companyMemberGroups.status;
});

/** Returns the group details entity for a specific group, or null if not loaded yet */
export function companyMemberGroupDetailSelector(groupId) {
  return createSelector(state => state.companyMemberGroups, companyMemberGroups => {
    if (!groupId) {
      return null;
    }
    return companyMemberGroupDetailsAdapter.getSelectors().selectById(companyMemberGroups, groupId) ?? null;
  });
}

/** Returns the fetching status for a specific group's details */
export function companyMemberGroupDetailStatusSelector(groupId) {
  return createSelector(state => state.companyMemberGroups, companyMemberGroups => {
    if (!groupId) {
      return "uninitialized";
    }
    return companyMemberGroups.groupDetailsStatus[groupId] ?? "uninitialized";
  });
}

/** Returns the projects belonging to a specific group */
export function companyMemberGroupProjectsSelector(groupId) {
  return createSelector(state => state.companyMemberGroups, companyMemberGroups => {
    if (!groupId) {
      return [];
    }
    const group = companyMemberGroupDetailsAdapter.getSelectors().selectById(companyMemberGroups, groupId);
    if (!group) {
      return [];
    }
    const {
      projectsMap
    } = companyMemberGroups;
    return (group.projectIds ?? []).flatMap(id => {
      const project = projectsMap[id];
      return project ? [project] : [];
    });
  });
}

/** Returns a member-group project by ID, or undefined if not found */
export function companyMemberGroupProjectByIdSelector(projectId) {
  return state => {
    if (!projectId) {
      return undefined;
    }
    return state.companyMemberGroups.projectsMap[projectId];
  };
}